/** Bekannte Terminals mit eigener Containerauskunft (H4/H6). Erweiterbar je neuem Adapter. */
export const TERMINALS = [
    { id: 'eurogate_infogate:HAM', platform: 'eurogate_infogate', locationCode: 'HAM', label: 'Eurogate Hamburg', port: 'DEHAM' },
    { id: 'eurogate_infogate:BRV', platform: 'eurogate_infogate', locationCode: 'BRV', label: 'Eurogate Bremerhaven', port: 'DEBRV' },
    { id: 'eurogate_infogate:CTW', platform: 'eurogate_infogate', locationCode: 'CTW', label: 'Eurogate Wilhelmshaven', port: 'DEWVN' },
    { id: 'hhla_coast:CTA', platform: 'hhla_coast', locationCode: 'CTA', label: 'HHLA Altenwerder (CTA)', port: 'DEHAM' },
    { id: 'hhla_coast:CTB', platform: 'hhla_coast', locationCode: 'CTB', label: 'HHLA Burchardkai (CTB)', port: 'DEHAM' },
    { id: 'hhla_coast:CTT', platform: 'hhla_coast', locationCode: 'CTT', label: 'HHLA Tollerort (CTT)', port: 'DEHAM' },
    { id: 'hdp2:HDP2', platform: 'hdp2', locationCode: 'HDP2', label: 'HDP2 Rotterdam (Delta II)', port: 'NLRTM' },
    { id: 'ntb:NTB', platform: 'ntb', locationCode: 'NTB', label: 'North Sea Terminal Bremerhaven (NTB)', port: 'DEBRV' },
];
/** Terminal per ID („<platform>:<locationCode>") auflösen. */
export function findTerminal(id) {
    return TERMINALS.find((t) => t.id === id);
}
/**
 * Ordnet einen frei geschriebenen Terminal-/Depot-Wert aus einer Kundenliste einem bekannten
 * Terminal mit eigener Containerauskunft zu (H6/Excel-Import). Kunden schreiben das Terminal sehr
 * unterschiedlich („Hamburg, Bukai HHLA CONTAINER TERMINAL BURCHA", „Eurogate CTH",
 * „Rotterdam, ECT Delta 8200"). Die Zuordnung ist BEWUSST konservativ: nur bei einem eindeutigen,
 * terminal-spezifischen Token (Eigenname/Terminalkürzel) wird gematcht — sonst `undefined` (lieber
 * kein Treffer als ein falsches Terminal). Reine Stadtangaben („Hamburg") genügen nicht, weil ein
 * Hafen mehrere Terminals hat. Erweiterbar je neuem Terminal-Adapter.
 */
export function matchTerminalByText(raw) {
    const u = (raw ?? '').toUpperCase();
    if (!u.trim())
        return undefined;
    const has = (s) => u.includes(s);
    const tok = (re) => re.test(u);
    let id;
    if (tok(/\bNTB\b/) || has('NORTH SEA TERMINAL'))
        id = 'ntb:NTB';
    else if (has('ALTENWERDER') || tok(/\bCTA\b/))
        id = 'hhla_coast:CTA';
    else if (has('BURCHARDKAI') || has('BURCHA') || has('BUKAI') || tok(/\bCTB\b/))
        id = 'hhla_coast:CTB';
    else if (has('TOLLERORT') || tok(/\bCTT\b/))
        id = 'hhla_coast:CTT';
    else if ((has('EUROGATE') && has('WILHELMSHAVEN')) || has('JADEWESERPORT') || tok(/\bJWP\b/) || tok(/\bCTW\b/))
        id = 'eurogate_infogate:CTW';
    else if (has('EUROGATE') && has('BREMERHAVEN'))
        id = 'eurogate_infogate:BRV';
    else if ((has('EUROGATE') && has('HAMBURG')) || tok(/\bCTH\b/))
        id = 'eurogate_infogate:HAM';
    else if (has('DELTA') && (has('ROTTERDAM') || has('ECT') || tok(/\bDELTA\s*(II|2)\b/) || has('MAASVLAKTE')))
        id = 'hdp2:HDP2';
    return id ? findTerminal(id) : undefined;
}
/**
 * Plattformen, deren Containerauskunft einen echten Browser (Playwright/Chromium) braucht. Diese
 * laufen NICHT in der API (kein Chromium) — die API delegiert sie an den Worker (BullMQ-Job).
 * Fetch-basierte Quellen (Eurogate/HHLA) prüft die API direkt.
 */
export const BROWSER_TERMINAL_PLATFORMS = new Set(['hdp2', 'ntb']);
/** True, wenn die Plattform browserbasiert ist (→ Worker-Delegation statt direkter API-Abfrage). */
export function isBrowserTerminalPlatform(platform) {
    return BROWSER_TERMINAL_PLATFORMS.has(platform);
}
//# sourceMappingURL=terminals.js.map